"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rePhoneNumber = void 0;
exports.rePhoneNumber = /\+62 \(\d\d\d\) \d\d\d\d-\d\d\d\d/;
//# sourceMappingURL=regexp.js.map